import { render, staticRenderFns } from "./self-info-modal.vue?vue&type=template&id=21eda0b6"
import script from "./self-info-modal.vue?vue&type=script&lang=js"
export * from "./self-info-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports